import React from "react";

const FraudulentActivities = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        T.
        <span className="text-[#01A7D1] ">
          {" "}
          Disclaimer for Fake Calls and Other Similar Phishing, Spamming or
          Fraudulent Activities
        </span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Please beware of fraudulent activities by unauthorized individuals or
        entities claiming to be associated with Yostel and/or its founders.
        These fraudsters attempt to deceive potential customers by using our
        company's name and reputation for their unlawful gains hence you are
        requested to verify the authenticity before initiating any payment.
        Please be informed that Yostel does not engage in any unsolicited
        communication, such as phone calls, emails, or messages, asking for
        sensitive personal information, account details, or any payment-related
        transactions. In no event shall Yostel be liable for any direct or
        indirect damages arising from reliance on the information provided in
        this warning. We disclaim any liability for losses or damages incurred
        due to fraudulent actions committed by third parties misrepresenting
        themselves as Yostel.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">Please note:</p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        - The room selection happens on a first-come-first-served basis and is
        subject to availability. We recommend you to come as soon as possible in
        order to have more options of rooms to select from.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        © 2025 Yostel. All Rights Reserved
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Copyright © 2025 | All Rights Reserved by Yostel
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Images shown are for representational purposes only. Amenities depicted
        may or may not form a part of that individual property.
      </p>
    </div>
  );
};

export default FraudulentActivities;
